import { Box, Button, Grid, InputAdornment, TextField,Typography } from "@mui/material";
import React, { useState } from "react";
import Gobutton from "../Gobutton";
import { Create } from "@mui/icons-material";
import ProgressLoader from "../Common/ProgressLoader";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

const ItemsContent = ({ assets, loader, url,defaultPageSize=10 }) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1},
    { field: "Title", headerName: "Title", flex: 1 },
    { field: "Type", headerName: "Type", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      width:100,
      renderCell: (params) => (
        <Button
          className="!px-1 !min-w-8"
          variant="contained"
          color="primary"
          onClick={() => handleCellClick(params.row)}
        >
          <Create className="!w-5 !h-5" />
        </Button>
      ),
    },
  ];

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleCellClick = (asset) => {
    navigate(`${url}/edit/${asset.id}`, {
      state: { editableAsset: asset },
    });
    setSelectedAsset(asset);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
        className="px-3 md:px-8 w-full !gap-3"
      > 
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <TextField
              size="small"
              label="Quick Search"
              sx={{ bgcolor: "background.paper" }}
              value={searchTerm}
              className="!mr-1 max-w-full md:max-w-full"
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item >
            <Gobutton
              text="Create New"
              startIcon={<Create />}
              url={{ type: "assets", url: `${url}/create` }}
            />
          </Grid>
        </Grid>

        <Grid className="assets-cards" container >
          {loader ? (
            <ProgressLoader />
          ) : (
            <DataGrid
              rows={assets.filter((asset) => {
                if (!asset || !asset.Title) {
                  return false;
                }
                return (
                  asset.Title.toLowerCase().includes(
                    searchTerm.toLowerCase()
                  ) ||
                  asset.email
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase()) ||
                  asset.id.toLowerCase().includes(searchTerm.toLowerCase())
                );
              })}
              columns={columns}
              autoPageSize={false}
              disableAutosize={false}
              value={selectedAsset}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: defaultPageSize },
                },
              }}
              pageSizeOptions={[5, 10, 25, 40]}
              checkboxSelection={false}
              className="mb-3"
              sx={{
                bgcolor: "background.paper",
                position: "relative",
              }}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
            />
          )}
        </Grid>
      </Box>
    </React.Fragment>
  );
};
export default ItemsContent;

const CustomNoRowsOverlay = () => {
  return (
    <Box
      sx={{
      display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",         
        width: "100%",          
        position: "absolute",  
        top: 0,
        left: 0,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h6" color="text.secondary">
        No data found
      </Typography>
    </Box>
  );
};
